import { BrowserService } from './browser.service';

export class WindowService implements BrowserService {
  constructor(protected windowRef: Window) {}

  openInNewTab(url: string): void {
    this.windowRef.open(url, '_blank');
  }

  changeLocationHref(url: string): void {
    this.windowRef.location.href = url;
  }

  getWindow(): Window | null {
    return this.windowRef;
  }

  isBrowser(): boolean {
    return true;
  }

  copyToClipboard(text: string): Promise<void> {
    return this.windowRef.navigator.clipboard.writeText(text);
  }
}
